import { ROUTES } from '@aibees/elephant/router';
import { usePathname, useRedirect } from '@aibees/shared/router';
import { classnames } from '@aibees/shared/utils';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { memo, startTransition, useEffect, useState } from 'react';
import { HeaderMenuItemConfig } from '../header-menu-item';
import * as SX from './sx';
import type { SwitchSearchProps as Props } from './types';

export const SwitchSearch = memo(({ className }: Props) => {
  const items: HeaderMenuItemConfig[] = [
    { title: 'Company Search', path: ROUTES.searchCompany },
    { title: 'People Search', path: ROUTES.searchPeople },
  ];
  const pathname = usePathname();
  const redirect = useRedirect();
  const [pendingPath, setPendingPath] = useState<string | null>(null);

  useEffect(() => {
    if (pendingPath && pathname === pendingPath) {
      setPendingPath(null);
    }
  }, [pathname, pendingPath]);

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: string
  ) => {
    if (!newValue || newValue === pathname) return;
    setPendingPath(newValue);
    startTransition(() => {
      redirect(newValue);
    });
  };

  const value = pendingPath ?? pathname;

  return (
    <Box className={classnames('SwitchSearch', className)} sx={SX.root}>
      <ToggleButtonGroup
        fullWidth
        onChange={handleChange}
        value={value}
        exclusive
      >
        {items.map((item) => {
          return (
            <ToggleButton
              disabled={item.disabled}
              size="small"
              color="primary"
              value={item.path}
              key={item.path}
            >
              {item.title}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </Box>
  );
});

SwitchSearch.displayName = 'SwitchSearch';
